import { useCallback, useState } from 'react';

/** The Time Tracker's two views (HR Module Prototype, Component Map › Time Tracker). */
export type TimesheetView = 'week' | 'list';

const STORAGE_KEY = 'hr-tt-view';

const read = (): TimesheetView => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'list' ? 'list' : 'week';
  } catch {
    return 'week';
  }
};

/** The Week / List choice, Week by default, remembered in this browser. */
export const useTimesheetView = () => {
  const [view, setViewState] = useState<TimesheetView>(read);
  const setView = useCallback((next: TimesheetView) => {
    setViewState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // Storage blocked (private window): the choice lasts until reload.
    }
  }, []);
  return [view, setView] as const;
};
